<template>
  <div class="d-book-user-review-author grid-flex grid-no-response">
    <div class="grid-item-shrink">
      <DUserLinkPopup
        :user-id="userId"
      >
        <template slot="content">
          <div class="grid-item-shrink avatar">
            <img
              class="user-avatar image-circle"
              :src="avatarUrl"
              :title="userName"
            >
          </div>
        </template>
      </DUserLinkPopup>
    </div>
    <div class="grid-item">
      <DUserLinkPopup
        :user-id="userId"
      >
        <template slot="content">
          <p class="user-name font-alt large">
            <strong>{{ userName }}</strong>
          </p>
        </template>
      </DUserLinkPopup>

      <div class="grid-flex grid-middle">
        <div class="grid-item-shrink space-right-1em">
          <DuiReviewRating
            :rating="rating"
            :video-review="hasVideoReview"
          />
        </div>
        <div class="grid-item">
          <span class="review-date">Reviewed on {{ publishedAt }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DUserLinkPopup from '@d-components/d-user-link-popup/d-user-link-popup.vue';

export default {
  components: {
    DUserLinkPopup,
  },
  props: {
    avatarUrl: {
      type: String,
      required: true,
    },
    hasVideoReview: {
      type: Boolean,
      default: false,
    },
    publishedAt: {
      type: String,
      required: true,
    },
    rating: {
      type: Number,
      required: true,
    },
    userName: {
      type: String,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-book-user-review-author {
  .user-avatar {
    height: $_6em;
    margin-right: $_2em;
    width: $_6em;
  }

  .user-name {
    margin: 0;
  }
}
</style>
